export enum FactoryType {
  DynamicValue = 'toDynamicValue',
  Factory = 'toFactory',
  Provider = 'toProvider',
}
